import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-external-link",
  "use": "icon-external-link-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-external-link\">\r\n    <path d=\"M15 7v2h4.6L12 16.6l1.4 1.4 7.6-7.6v4.5h2V7zm8 11v4c0 .6-.4 1-1 1H8c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1h4v1H8v14h14v-4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol